import apiShopkeeperApp from '../../../api/shopkeeperAppApi';

export default {
  save({}, fields) {
    return apiShopkeeperApp.post('/imagens-categorias-update', fields);
  },
  listCategorias({}) {
    return apiShopkeeperApp.get('/imagens-categorias', {
    });
  }
};
